import {PriceValue} from '../../../types/PriceValue';
import {isPriceFromWithVat} from './isPriceFromWithVat';

export const isValidPrice = (value?: PriceValue | null) =>
  isPriceFromWithVat(value)
    ? !!value?.withVat?.amount && !!value?.withVat?.currency
    : !!value?.withoutVat?.amount && !!value?.withoutVat?.currency;
